import DesignControlsForOneColorIcon from './DesignControlsForOneColorIcon';
import DesignControlsForTwoColorIcon from './DesignControlsForTwoColorIcon';

export {DesignControlsForOneColorIcon, DesignControlsForTwoColorIcon};
